import * as React from 'react';

interface Props {
	className?: string;
	user: UserDetails;
}
const FailedPaymentUserDetails: React.StatelessComponent<Props> = props => {
	return (
		<div className={props.className}>
			<h2 className="form-fieldset-title">Customer Details</h2>
			<div className="form-fieldset">
				<ul className="list-unstyled mb-0">
					<li><strong>Name:</strong> {props.user.fullName}</li>
					<li><strong>Email:</strong> {props.user.email}</li>
					<li><strong>Phone:</strong> {props.user.phoneNumber || '-'}</li>
					<li><strong>Stripe customer id:</strong> {props.user.stripeCustomerId}</li>
				</ul>
			</div>
		</div>
	);
};
export default FailedPaymentUserDetails;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/FailedPaymentUserDetails.tsx